import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const otpVerified = localStorage.getItem('otp_verified');
    const authToken = localStorage.getItem('at'); 

    if (otpVerified === 'true' && authToken) {
      return true;
    } else {
      this.router.navigate(['/login']); 
      return false;
    }
  }
}
